import React from 'react'
import { useCoachChat } from './CoachChatContext'
import { useTranslation } from '~/hooks/useTranslation'
import { getWaitingTitleClass } from './coachDashboardStyles'

/**
 * CoachChatWaiting component - displays when coach is waiting for incoming calls
 * or inactive (unavailable). Shows "INACTIVE" when availability is 'away'.
 */
const CoachChatWaiting = ({ embedded = false }) => {
  const { getDarkModeClasses, connectionState, initialAvailability } =
    useCoachChat()
  const { t } = useTranslation('coach_chat')

  const availability = connectionState?.availability ?? initialAvailability
  const isUnavailable = availability === 'away'
  const title = isUnavailable
    ? t('coach_waiting.inactive_title', 'INACTIVE')
    : t('coach_waiting.waiting_title', "YOU'RE LIVE!")
  const subtitle = isUnavailable
    ? t(
        'coach_waiting.inactive_subtitle',
        "You're currently not ready for chats. Set your status to 'Live' to begin receiving candidates.",
      )
    : t(
        'coach_waiting.waiting_subtitle',
        "You are currently live and available and waiting for candidates to start a chat. When a candidate initiates a chat, you'll see an incoming call notification here.",
      )

  const containerClasses = embedded
    ? 'flex flex-col text-left'
    : `flex h-full flex-col items-center justify-center rounded-lg p-8 text-center ${getDarkModeClasses(
        'bg-gray-50',
        'bg-gray-800',
      )}`

  return (
    <div className={containerClasses}>
      <h3
        className={`mb-2 font-['Roboto'] text-xl font-semibold tracking-wide ${getWaitingTitleClass(isUnavailable, getDarkModeClasses)}`}
      >
        {title}
      </h3>
      <p
        className={`font-['Roboto'] text-sm leading-relaxed ${getDarkModeClasses(
          'text-gray-600',
          'text-gray-400',
        )}`}
      >
        {subtitle}
      </p>
    </div>
  )
}

export default CoachChatWaiting
